import React from 'react';

import { Stack } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';


import { setActiveBaseLayer } from '../store/actions/mapActions';
import { osmPicto, orthoPicto } from '../mapStyles';

export const MapType = ({ariaLabel, value, imgSrc}) => {
  const activeBaseLayer = useSelector(state => state.map.activeBaseLayer);
  const checked = value === activeBaseLayer ? true: false;

  const styles = {
    typeSelect: {
      display: 'flex',
      border: '0.3em solid',
      borderRadius : '0.5em',
      minWidth: '4.3em',
      width: '4.3em',
      height: '4.3em',
      padding: 0
    }
  };

  const dispatch = useDispatch();
  const setToType = (event) => {
    event.preventDefault();
    if (!checked) {
      dispatch(setActiveBaseLayer(value));
    }
  };
  return (
    <Button 
      color={checked ? 'mapTypeActive' : 'mapTypeNonActive'} 
      aria-label={ariaLabel}
      sx={styles.typeSelect}
      onClick={setToType}>
      <img aria-hidden={true} src={imgSrc} width='100%' height='100%'/>
    </Button>
  );
};

export const MaptypeBar = ({direction='column'}) => {
  const {t} = useTranslation();
  return (
    <Stack direction={direction} spacing={1}>
      <MapType ariaLabel={t('background-map.show-map')} value={'osm-tiles'} imgSrc={osmPicto}/>
      <MapType ariaLabel={t('background-map.show-satellite')} value={'ortho-tiles'} imgSrc={orthoPicto}/>
    </Stack>
  );
};